import { lazyNamed, loadable, Loading } from '@work4all/components';

export const SimplePDFReportLazy = lazyNamed(
  () => import('./SimplePDFReport'),
  'SimplePDFReport'
);

export const SimplePDFReport = loadable(SimplePDFReportLazy, <Loading />);
